import { Card} from "../ui/card"
import { useNavigate } from "react-router-dom";
export default function Course ({course}) {
  const navigate = useNavigate()
  return (
    <Card className="flex flex-col group p-4 gap-2 shadow-sm hover:shadow-lg cursor-pointer"
    onClick={() => navigate(`/courses/${course.id}`)}
    >
      <div className="bg-no-repeat h-48 w-full bg-center rounded-lg" style={{backgroundImage: `url('${process.env.REACT_APP_API_ENDPOINT_URL}/files/${course.image_id}')`}}></div>
      <h2 className="text-lg font-semibold">{course.title}</h2>
      <p className="text-sm">{course.description}</p>
      <div className="mt-auto">
        <span className="font-semibold group-hover:text-primary group-hover:scale-150">
          {parseInt(course.price,10).toLocaleString("vi-VN")} VND
        </span>
      </div>
    </Card>
  )
}
